// extracted by mini-css-extract-plugin
export default {"rectangle":"AdCard_rectangle__YZrgZ","buttonSelected":"AdCard_buttonSelected__Oc8aG"};